import React, { FC, Fragment, useState } from 'react'
import { observer } from 'mobx-react'
import { cartMobx } from 'restaurant'
import { classNames, format } from '@dt/fe-utils'
import { ProductImage, BagIcon, Tags } from '@cps'
import { TimePickBar } from '@pages/checkout/component'
import CartPackPicker from '../CartPackPicker'
import './index.scss'

const CartOrderSwapBuys: FC = () => {
  const handleRemove = (cartItem: IViewCartItem) => {
    cartMobx.remove(cartItem.pk)
  }

  const handleChangePackCnt = (cartItem: IViewCartItem, cnt: number) => {
    cartMobx.setCarPackFkeys(`${cartItem.fkey}_${cartItem.pk}`, cnt)
  }

  if (!cartMobx.viewOrderSwapBuyCartItems?.length) {
    return null
  }

  return (
    <div className='cart-order-swap-buy-wrapper'>
      <div className='cart-osb-title'>{i18n.t('checkout.orderSwapBuy.name')}</div>
      {cartMobx.viewOrderSwapBuyCartItems?.map((cartItem) => (
        <div
          className={classNames('cart-product-item', {
            'disable-cart-items': cartItem.disabled,
            'disable-togo': cartMobx.needPack && !cartItem.isCanTogo
          })}
          key={cartItem.pk}
        >
          {!cartMobx.needPack && (
            <div className='remove-item'>
              <i
                className='iconfont icon-huabanbeifen32x'
                data-cypid={`cartOrderSwapBuy_pk_${cartItem?.pk}`}
                onClick={() => handleRemove(cartItem)}
              >
              </i>
            </div>
          )}
          <div className='product-info'>
            <div className='item-detail'>
              <ProductImage width={40} imgSrc={cartItem.pic} />
              <div className='product-name'>
                <strong>{!cartMobx.needPack && !!cartItem.isTogo && <BagIcon size='small' />}{cartItem.name}</strong>
                <small className='grey'>{cartItem.optionStr}</small>
                <div className='product-extra-info'>
                  <Tags datas={[...(cartItem.tags || []), ...(cartItem.allergys || [])]} disableSingleSale={!cartItem.isSingleSale} />
                </div>
                {!!cartMobx.needPack && !cartItem.isCanTogo && <span className='disable-togo'>{i18n.t('newCart.productCanNotTogo')}</span>}
                {cartItem.startTime && <TimePickBar type='product' scene='swapBuy' cartItem={cartItem} />}
              </div>
              <div className='product-price'>
                <span dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(cartItem.actualPrice || 0) }}></span>
                {cartItem.actualPrice !== cartItem.totalPrice && (
                  <del dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(cartItem.totalPrice || 0) }}></del>
                )}
              </div>
            </div>
            {cartItem.disabled && (<div className='item-disabled'>{i18n.t(`checkout.disabledReason.${(cartItem.disabledReason === 'ORDERSWAPBUYINEFFECTIVE' ? 'ORDERSWAPBUYINEFFECTIVE' : 'soldout').toLocaleLowerCase()}`)}</div>)}
            {cartMobx.needPack && cartItem.isCanTogo && (
              <CartPackPicker
                cnt={cartMobx.cartPackFkeys[`${cartItem.fkey}_${cartItem.pk}`] || 0}
                total={cartItem.cnt}
                onChange={cnt => handleChangePackCnt(cartItem, cnt)}
              />
            )}
          </div>
        </div>
      ))}
    </div>
  )
}

export default observer(CartOrderSwapBuys)
